// extracted by mini-css-extract-plugin
export var contact_form = "contactForm-module--contact_form--49de0";
export var contact_form_wrapper = "contactForm-module--contact_form_wrapper--033b9";
export var radios = "contactForm-module--radios--27b7b";
export var result = "contactForm-module--result--4be11";